import * as settings from "../constants/settings";
import * as getterHelper from "./getterHelper";

const L_COEF = 1000;
const KG_COEF = 1000;
const US_GALLON_COEF = 3785.41178;
const US_QUARTS_COEF = 946.352946;
const IMP_GALLON_COEF = 4546.09;
const IMP_QUARTS_COEF = 1136.5225;

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
const convertMl = (value, target, density, shotsCoef) => {
    if (target === settings.UNIT_G) {
        return value * density;
    }

    if (target === settings.UNIT_SHOT) {
        if (shotsCoef > 0) {
            return value / shotsCoef;
        }

        return 0;
    }

    if (target === settings.UNIT_L) {
        return value / L_COEF;
    }

    if (target === settings.UNIT_KG) {
        return (value * density) / KG_COEF;
    }

    if (target === settings.UNIT_US_GALLON) {
        return value / US_GALLON_COEF;
    }

    if (target === settings.UNIT_US_QUARTS) {
        return value / US_QUARTS_COEF;
    }

    if (target === settings.UNIT_IMP_GALLON) {
        return value / IMP_GALLON_COEF;
    }

    if (target === settings.UNIT_IMP_QUARTS) {
        return value / IMP_QUARTS_COEF;
    }

    return value;
};

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
const convertG = (value, target, density, shotsCoef) => {
    if (target === settings.UNIT_ML) {
        if (density > 0) {
            return value / density;
        }

        return 0;
    }

    if (target === settings.UNIT_L) {
        if (density > 0) {
            return value / density / L_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_SHOT) {
        if (density > 0 && shotsCoef > 0) {
            return value / density / shotsCoef;
        }

        return 0;
    }

    if (target === settings.UNIT_KG) {
        return value / KG_COEF;
    }

    if (target === settings.UNIT_US_GALLON) {
        if (density > 0) {
            return value / density / US_GALLON_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_US_QUARTS) {
        if (density > 0) {
            return value / density / US_QUARTS_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_IMP_GALLON) {
        if (density > 0) {
            return value / density / IMP_GALLON_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_IMP_QUARTS) {
        if (density > 0) {
            return value / density / IMP_QUARTS_COEF;
        }

        return 0;
    }

    return value;
};

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
const convertShot = (value, target, density, shotsCoef) => {
    if (target === settings.UNIT_ML) {
        return value * shotsCoef;
    }

    if (target === settings.UNIT_L) {
        return (value * shotsCoef) / L_COEF;
    }

    if (target === settings.UNIT_G) {
        return value * shotsCoef * density;
    }

    if (target === settings.UNIT_KG) {
        return (value * shotsCoef * density) / KG_COEF;
    }

    if (target === settings.UNIT_US_GALLON) {
        return (value * shotsCoef) / US_GALLON_COEF;
    }

    if (target === settings.UNIT_US_QUARTS) {
        return (value * shotsCoef) / US_QUARTS_COEF;
    }

    if (target === settings.UNIT_IMP_GALLON) {
        return (value * shotsCoef) / IMP_GALLON_COEF;
    }

    if (target === settings.UNIT_IMP_QUARTS) {
        return (value * shotsCoef) / IMP_QUARTS_COEF;
    }

    return value;
};

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
const convertKg = (value, target, density, shotsCoef) => {
    if (target === settings.UNIT_ML) {
        if (density > 0) {
            return (value / density) * L_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_L) {
        if (density > 0) {
            return value / density;
        }

        return 0;
    }

    if (target === settings.UNIT_G) {
        return value * KG_COEF;
    }

    if (target === settings.UNIT_SHOT) {
        if (density > 0 && shotsCoef > 0) {
            return (value / density / shotsCoef) * 1000;
        }

        return 0;
    }

    if (target === settings.UNIT_US_GALLON) {
        if (density > 0) {
            return ((value / density) * L_COEF) / US_GALLON_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_US_QUARTS) {
        if (density > 0) {
            return ((value / density) * L_COEF) / US_QUARTS_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_IMP_GALLON) {
        if (density > 0) {
            return ((value / density) * L_COEF) / IMP_GALLON_COEF;
        }

        return 0;
    }

    if (target === settings.UNIT_IMP_QUARTS) {
        if (density > 0) {
            return ((value / density) * L_COEF) / IMP_QUARTS_COEF;
        }

        return 0;
    }

    return value;
};

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
const convertL = (value, target, density, shotsCoef) => {
    if (target === settings.UNIT_G) {
        return value * density * KG_COEF;
    }

    if (target === settings.UNIT_SHOT) {
        if (shotsCoef > 0) {
            return (value / shotsCoef) * 1000;
        }

        return 0;
    }

    if (target === settings.UNIT_KG) {
        return value * density;
    }

    if (target === settings.UNIT_ML) {
        return value * L_COEF;
    }

    if (target === settings.UNIT_US_GALLON) {
        return (value * L_COEF) / US_GALLON_COEF;
    }

    if (target === settings.UNIT_US_QUARTS) {
        return (value * L_COEF) / US_QUARTS_COEF;
    }

    if (target === settings.UNIT_IMP_GALLON) {
        return (value * L_COEF) / IMP_GALLON_COEF;
    }

    if (target === settings.UNIT_IMP_QUARTS) {
        return (value * L_COEF) / IMP_QUARTS_COEF;
    }

    return value;
};

/**
 * @param   {Number}    value
 * @param   {String}    target
 * @param   {String}    colorantName
 * @param   {Array}     allColorantList
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
export const convertAmountByColorantName = (value, source, target, colorantName, allColorantList, shotsCoef) => {
    let density = 0;

    if (
        source === settings.UNIT_G ||
        target === settings.UNIT_G ||
        source === settings.UNIT_KG ||
        target === settings.UNIT_KG
    ) {
        let colorant = getterHelper.getObjectByName(allColorantList, colorantName);

        if (colorant !== null) {
            density = colorant.density;
        }
    }

    if (source === settings.UNIT_ML) {
        return convertMl(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_G) {
        return convertG(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_SHOT) {
        return convertShot(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_KG) {
        return convertKg(value, target, density, shotsCoef);
    }

    return value;
};

/**
 * @param   {Object}    colorant
 * @param   {String}    source
 * @param   {String}    target
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
export const convertAmountByColorant = (colorant, source, target, shotsCoef) => {
    if (source === settings.UNIT_ML) {
        return convertMl(colorant.amount, target, colorant.density, shotsCoef);
    }

    if (source === settings.UNIT_G) {
        return convertG(colorant.amount, target, colorant.density, shotsCoef);
    }

    if (source === settings.UNIT_SHOT) {
        return convertShot(colorant.amount, target, colorant.density, shotsCoef);
    }

    if (source === settings.UNIT_KG) {
        return convertKg(colorant.amount, target, colorant.density, shotsCoef);
    }

    return colorant.amount;
};

/**
 * @param   {Number}    value
 * @param   {String}    source
 * @param   {String}    target
 * @param   {Number}    density
 * @param   {Number}    shotsCoef
 * @returns {Number}
 */
export const convertByUnits = (value, source, target, density = 1, shotsCoef = 1) => {
    if (source === settings.UNIT_L) {
        return convertL(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_ML) {
        return convertMl(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_G) {
        return convertG(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_SHOT) {
        return convertShot(value, target, density, shotsCoef);
    }

    if (source === settings.UNIT_KG) {
        return convertKg(value, target, density, shotsCoef);
    }

    return value;
};

/**
 * @param   {Array}     colorantList
 * @param   {String}    source
 * @param   {String}    target
 * @param   {Number}    shotsCoef
 * @returns {Array}
 */
export const convertColorantList = (colorantList, source, target, shotsCoef = 1, shotsName = settings.UNIT_SHOT) => {
    let result = [];

    let colorant;
    for (colorant of colorantList) {
        result.push(
            colorant.updateAmountValues(
                convertAmountByColorant(colorant, source, target, shotsCoef),
                target === settings.UNIT_SHOT ? shotsName : target
            )
        );
    }

    return result;
};

/**
 * @param   {Array}     colorantList
 * @param   {String}    source
 * @param   {String}    target
 * @param   {Number}    shotsCoef
 * @param   {Array}     originalColorantList
 * @returns {Array}
 */
export const convertEditedColorantList = (colorantList, source, target, shotsCoef, shotsName, originalColorantList) => {
    let result = [];

    let colorant, updatedColorant;
    for (colorant of colorantList) {
        if (colorant.correction === 0) {
            result.push(
                getterHelper.getObjectById(originalColorantList, colorant.id) ??
                    colorant.updateAmountValues(
                        convertAmountByColorant(colorant, source, target, shotsCoef),
                        target === settings.UNIT_SHOT ? shotsName : target
                    )
            );
        } else {
            updatedColorant = colorant.updateAmountValues(
                convertAmountByColorant(colorant, source, target, shotsCoef),
                target === settings.UNIT_SHOT ? shotsName : target
            );
            result.push(
                updatedColorant.updateCorrection(
                    convertByUnits(colorant.correction, source, target, colorant.density, shotsCoef)
                )
            );
        }
    }

    return result;
};
